import { z } from 'zod'
import { useApi } from '../../utils/useApi'

const EditPayloadSchema = z.object({
    changes: z.array(
        z.object({
            field: z.string(),
            before: z.string(),
            after: z.string()
        })
    )
})

const ExecutePayloadSchema = z.object({
    action_type: z.enum(['force_update', 'sms']),
    message: z.string()
})

const ChangeLogEntrySchema = z.object({
    event_id: z.string(),
    timestamp: z.string(),
    actor: z.string(),
    operation: z.enum(['edit', 'execute']),
    reason: z.string().nullable(),
    target_type: z.enum(['device', 'station', 'lot']),
    target_id: z.string(),
    payload: z.union([EditPayloadSchema, ExecutePayloadSchema])
})

const ChangeLogResponseSchema = z.object({
    change_log: z.array(ChangeLogEntrySchema)
})

export type ChangeLogEntry = z.infer<typeof ChangeLogEntrySchema>
export type EditPayload = z.infer<typeof EditPayloadSchema>
export type ExecutePayload = z.infer<typeof ExecutePayloadSchema>
export const AuditTargetType = {
    lot: 'lot',
    station: 'station',
    device: 'device'
} as const

export type AuditTargetType = (typeof AuditTargetType)[keyof typeof AuditTargetType]

export const useChangeLogQuery = (targetId: string | undefined, targetType: AuditTargetType) =>
    useApi(
        '/platform/device/get_change_log',
        { target_id: targetId, target_type: targetType },
        ChangeLogResponseSchema,
        {
            queryKey: ['changeLog', targetId, targetType],
            enabled: Boolean(targetId),
            retry: false
        }
    )
